export default function useCountdown (countdown: number = 30) {
  const timer = ref<number>(countdown);

  function resetCountDown () {
    timer.value = countdown;
  }

  function startCountdown () {
    timer.value = countdown;
    const timerInterval = setInterval(() => {
      if (timer.value > 0) {
        timer.value = timer.value - 1;
      } else {
        clearInterval(timerInterval);
      }
    }, 1000);
  }

  const timerValue = computed(() => timer.value);

  return {
    timer: timerValue,
    startCountdown,
    resetCountDown
  };
}
